import React, { Suspense, useCallback, useContext, useEffect } from "react";
import { useState } from "react";

import { Link } from "react-router-dom";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import $ from "jquery";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import { TostMsg } from "../../../App";
import { LazyImage } from "../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import moment from "moment";
import { Dropdown } from "primereact/dropdown";

import {
  GetEmpAssessmentPeriodList,
} from "./PMSService";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader";



function AssessmentCycle() {
 
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  let userPermissions = JSON.parse(localStorage.getItem("Permissions") || "{}");
  const toster = useContext(TostMsg);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
let history = useHistory();
  const [play, setPlay] = useState(false);
  const [activeFAQIndex, setActiveFAQIndex] = useState(null);
  const [EmpAssessmentList, setEmpAssessmentList] = useState([]);
  const [loading, setLoading] = useState(false);
  const defaultImage = "/images/placeholder_profile.png";
  const { GUID } = useParams();
  const [EmpAssessmentListCount, setEmpAssessmentListCount] = useState([]);
  const [eligibleEmployees, setEligibleEmployees] = useState([]);
  const [assessmentfetchPeriod, setAssessmentfetchPeriod] = useState([]);
  const [selectedPeriod, setSelectedPeriod] = useState("");
  const steps = ["Initiated", "Submitted", "Reviewed", "Closed"];
  const [selectedRaiseBy, setSelectedRaiseBy] = useState("");
  const [selectedAssignToName, setSelectedAssignToName] = useState("");

  const currentStatus =
    EmpAssessmentList[0]?.AssessmentPeriodStatus || "Created";

  // const currentIndex = steps.indexOf(currentStatus);

  useEffect(() => {
    getEmpAssessmentPeriodId();
    empAssessmentPeriodAllList();
  }, [GUID]);

 
  async function empAssessmentPeriodAllList() {
    const body = {
      OrgId: userDetails?.OrgId,
      LoggedInUserId: userDetails?.EmpId,
      OAPGuId: "",
      Search: "",
      PageNumber: 1,
      PageSize: 1000,
    };
    try {
      let response = await GetEmpAssessmentPeriodList(body);
      let periodData = response?.Data?.assessmentPresiodResponse.map((item) => {
        // const id = item?.GUID;
        const from = new Date(item.From);
        const to = new Date(item.To);
        const options = { day: "2-digit", month: "long", year: "numeric" };
        return {
          ...item,
          label: `${from.toLocaleDateString(
            "en-GB",
            options
          )} - ${to.toLocaleDateString("en-GB", options)}`,
          value: item.GUID,
        };
      });
      setAssessmentfetchPeriod(periodData);
    } catch (error) {
      toster.current.error(ERROR_LIST?.EmpAssessmentList);
    }
  }

  const handleInputChangePeriod = (e) => {
   
    setSelectedPeriod(e.value);
    history?.push(`/Assessment/Cycle/Details/${e.value}`);
  };

  async function getEmpAssessmentPeriodId() {
    setLoading(true);
    const body = {
      OrgId: userDetails?.OrgId,
      LoggedInUserId: userDetails?.EmpId,
      OAPGuId: GUID,
      Search: "",
      PageNumber: 1,
      PageSize: 1000,
    };
    try {
      let response = await GetEmpAssessmentPeriodList(body);
      // setEmpAssessmentListCount(response?.Data);
      setEmpAssessmentList(response?.Data?.assessmentPresiodResponse);
      setEligibleEmployees(
        response?.Data?.assessmentPresiodResponse[0]?.eligibleEmployeeList
      );
      setLoading(false);
    } catch (error) {
      toster.current.error(ERROR_LIST?.EmpAssessmentList);
    }
  }



 



  
  const navigatePage = (guid, value) => {
    history.push(`/Assessment/EditAssessment/${guid}`);
    // const stepMap = {
    //   1: "assessment",
    //   2: "question",
    //   3: "employee",
    // };
  
    // const step = stepMap[value];
  
    // if (!step) return;
  
    // window.open(
    //   `/Assessment/EditNewAssessment/${guid}?step=${step}`,
    //   "_blank"
    // );
  };

  return (
    <div>
      <div id="circular-menu" className="circular-menu">
        <a className="floating-btn">
          <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
          <i aria-hidden="true" className="fa fa-times"></i>
        </a>

        <div className="items-wrapper">
          <div className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </div>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="languages-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </a>
          <Link to="" className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </Link>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="activity-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-grid"
            >
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
          </a>
        </div>
      </div>
      {/* <!-- row --> */}
      <div className="container-fluid">
        <div className="row g-3 assessment-module">
          <div className="col-xl-12">
            <div className="form-head d-flex flex-wrap align-items-center">
              <div className="me-auto">
                <h2 className="font-w600 mb-0">Assessment Cycles Detail</h2>
              </div>

              <div className="rightside-tabs">
                <Dropdown
                  name="period"
                  value={selectedPeriod}
                  onChange={(e) => {
                    setSelectedPeriod(e.value);
                    handleInputChangePeriod(e);
                  }}
                  options={assessmentfetchPeriod}
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Select a Period"
                  className="form-control"
                  checkmark={true}
                  highlightOnSelect={false}
                />
                {/* <select className="form-control">
                  <option disabled>Select Period</option>
                  <option selected>01 April 2022 - 31 March 2023</option>
                  <option>01 April 2021 - 31 March 2022</option>
                  <option>01 April 2020 - 31 March 2021</option>
                </select> */}
                <Link to="/AssessmentCycles">
                  <button className="cancelbutton w-auto btn">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="17"
                      height="17"
                      fill="currentColor"
                      className="bi bi-arrow-left me-2"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"
                      ></path>
                    </svg>
                    Back
                  </button>
                </Link>
              </div>
            </div>
          </div>
          <div className="col-xl-12">
            <div className="page-content-inner all-projects mt-0">
              <div className="tickets-summary">
                <div className="column">
                  <img src="/images/org-img/leave/popup-backimg.png" />
                  <div className="dashboard-tile">
                    <div className="tile-head">
                      <h3 className="dark-inverted">Employees in Cycle</h3>
                      <div className="h-icon is-primary is-rounded is-small">
                        <i aria-hidden="true" className="fas fa-gem"></i>
                      </div>
                    </div>
                    <div className="tile-body">
                      <span className="dark-inverted">
                        {EmpAssessmentListCount?.TotalEligibleEmployees}
                      </span>
                    </div>
                    <div className="tile-foot">
                      <span className="text-h-green"></span>
                      <span>Current</span>
                    </div>
                  </div>
                </div>
                <div className="column">
                  <img src="/images/org-img/leave/popup-backimg.png" />
                  <div className="dashboard-tile">
                    <div className="tile-head">
                      <h3 className="dark-inverted">Self Assessments</h3>
                      <div className="h-icon is-primary is-rounded is-small">
                        <i aria-hidden="true" className="fas fa-gem"></i>
                      </div>
                    </div>
                    <div className="tile-body">
                      <span className="dark-inverted">
                        {EmpAssessmentListCount?.TotalEligibleEmployees}
                      </span>
                    </div>
                    <div className="tile-foot">
                      <span className="text-h-green"></span>
                      <span>Completed</span>
                    </div>
                  </div>
                </div>
                <div className="column">
                  <img src="/images/org-img/leave/popup-backimg.png" />
                  <div className="dashboard-tile">
                    <div className="tile-head">
                      <h3 className="dark-inverted">Manager Reviews</h3>
                      <div className="h-icon is-primary is-rounded is-small">
                        <i aria-hidden="true" className="fas fa-gem"></i>
                      </div>
                    </div>
                    <div className="tile-body">
                      <span className="dark-inverted">
                        {EmpAssessmentListCount?.TotalEligibleEmployees}
                      </span>
                    </div>
                    <div className="tile-foot">
                      <span className="text-h-green"></span>
                      <span>Completed</span>
                    </div>
                  </div>
                </div>
                <div className="column">
                  <img src="/images/org-img/leave/popup-backimg.png" />
                  <div className="dashboard-tile">
                    <div className="tile-head">
                      <h3 className="dark-inverted">Senior Level Review</h3>
                      <div className="h-icon is-primary is-rounded is-small">
                        <i aria-hidden="true" className="fas fa-gem"></i>
                      </div>
                    </div>
                    <div className="tile-body">
                      <span className="dark-inverted">
                        {EmpAssessmentListCount?.TotalEligibleEmployees}
                      </span>
                    </div>
                    <div className="tile-foot">
                      <span className="text-h-green"></span>
                      <span> Completed</span>
                    </div>
                  </div>
                </div>
                <div className="column">
                  <img src="/images/org-img/leave/popup-backimg.png" />
                  <div className="dashboard-tile">
                    <div className="tile-head">
                      <h3 className="dark-inverted">HR Normalisation</h3>
                      <div className="h-icon is-primary is-rounded is-small">
                        <i aria-hidden="true" className="fas fa-gem"></i>
                      </div>
                    </div>
                    <div className="tile-body">
                      <span className="dark-inverted">
                        {EmpAssessmentListCount?.TotalEligibleEmployees}
                      </span>
                    </div>
                    <div className="tile-foot">
                      <span className="text-h-green"></span>
                      <span> Completed</span>
                    </div>
                  </div>
                </div>
                <div className="column">
                  <img src="/images/org-img/leave/popup-backimg.png" />
                  <div className="dashboard-tile">
                    <div className="tile-head">
                      <h3 className="dark-inverted">Total Days Taken</h3>
                      <div className="h-icon is-primary is-rounded is-small">
                        <i aria-hidden="true" className="fas fa-gem"></i>
                      </div>
                    </div>
                    <div className="tile-body">
                      <span className="dark-inverted">
                        {EmpAssessmentListCount?.TotalEligibleEmployees}
                      </span>
                    </div>
                    <div className="tile-foot">
                      <span className="text-h-green"></span>
                      <span>Current</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-12">
            <div className="assessment-detail-block">
              <div className="illustration-header00">
                <div className="header-meta">
                  <div className="first-divblock">
                    <div>
                      <h3>
                        {" "}
                        FY {moment(EmpAssessmentList[0]?.From).format("YY")}-
                        {moment(EmpAssessmentList[0]?.To).format("YY")}{" "}
                        {EmpAssessmentList[0]?.Title}
                      </h3>
                      <ul className="basicinfomation">
                        <li>
                          <i className="fa fa-calendar" aria-hidden="true"></i>
                          {moment(EmpAssessmentList[0]?.StartedOn).format(
                            "MMM DD YYYY"
                          )}{" "}
                          -{" "}
                          {moment(EmpAssessmentList[0]?.EndedOn).format(
                            "MMM DD YYYY"
                          )}
                        </li>
                        <li>
                          <i className="fa fa-user-o" aria-hidden="true"></i>
                          Total Employee :{" "}
                          <b className="emp-count">
                            {EmpAssessmentList[0]?.TotalEligibleEmployees}
                          </b>
                        </li>
                      </ul>
                    </div>
                    <div className="saving-btnhr">
                      <div className="progress">
                        <div
                          className="progress-bar progress-bar-success progress-bar-striped"
                          role="progressbar"
                          aria-valuenow="60"
                          aria-valuemin="0"
                          aria-valuemax="100"
                          style={{ width: "60%" }}
                        >
                          60% Complete
                        </div>
                      </div>
                      {play == false ? (
                        <button
                          onClick={() => setPlay(true)}
                          className="add-m saveby-employee"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Start"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            className="bi bi-play-fill"
                            viewBox="0 0 16 16"
                          >
                            <path d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z" />
                          </svg>
                        </button>
                      ) : (
                        <button
                          onClick={() => setPlay(false)}
                          className="update-m submitby-employee"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Pause"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-pause-circle"
                            viewBox="0 0 16 16"
                          >
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                            <path d="M5 6.25a1.25 1.25 0 1 1 2.5 0v3.5a1.25 1.25 0 1 1-2.5 0v-3.5zm3.5 0a1.25 1.25 0 1 1 2.5 0v3.5a1.25 1.25 0 1 1-2.5 0v-3.5z" />
                          </svg>
                        </button>
                      )}

                      <button
                        className="remove-m submitby-employer"
                        data-toggle="tooltip"
                        data-placement="top"
                        data-bs-toggle="modal"
                        data-bs-target="#delete-ed"
                        title="Remove"
                        data-bs-original-title="delete"
                        aria-label="delete"
                        // onClick={() => setAnnouncementDeleteId(lst?.Id)}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-trash"
                          viewBox="0 0 16 16"
                        >
                          <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z" />
                          <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z" />
                        </svg>
                      </button>
                      <button
                      onClick={() => navigatePage(GUID,1)}
                        className="import-m saveby-employee"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Edit"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-pencil"
                          viewBox="0 0 16 16"
                        >
                          <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z" />
                        </svg>
                      </button>
                      {/* <button className="view-m saveby-employee me-2" data-toggle="tooltip" data-placement="top" title="View">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-eye" viewBox="0 0 16 16">
                                                                        <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
                                                                        <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                                                                    </svg></button> */}
                      <button
                        className="assign-m submitby-employer"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Send reminder"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-send-check"
                          viewBox="0 0 16 16"
                        >
                          <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855a.75.75 0 0 0-.124 1.329l4.995 3.178 1.531 2.406a.5.5 0 0 0 .844-.536L6.637 10.07l7.494-7.494-1.895 4.738a.5.5 0 1 0 .928.372l2.8-7Zm-2.54 1.183L5.93 9.363 1.591 6.602l11.833-4.733Z" />
                          <path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-1.993-1.679a.5.5 0 0 0-.686.172l-1.17 1.95-.547-.547a.5.5 0 0 0-.708.708l.774.773a.75.75 0 0 0 1.174-.144l1.335-2.226a.5.5 0 0 0-.172-.686Z" />
                        </svg>
                      </button>
                    </div>
                  </div>
                  <div className="summary-stats">
                    <div className="summary-stat">
                      <img src="/images/pms/start-date.svg" />
                      <div>
                        <span>Initiated On</span>
                        <span>
                          {" "}
                          {moment(EmpAssessmentList[0]?.StartedOn).format(
                            "MMM DD YYYY"
                          )}
                        </span>
                      </div>
                    </div>
                    <div className="summary-stat">
                      <img src="/images/pms/start-date.svg" />
                      <div>
                        <span>Self Assessment By</span>
                        <span>
                          {" "}
                          {moment(
                            EmpAssessmentList[0]?.SelfAssesmentClosureDate
                          ).format("MMM DD YYYY")}
                        </span>
                      </div>
                    </div>
                    <div className="summary-stat">
                      <img src="/images/pms/end-date.svg" />
                      <div>
                        <span>First Review By</span>
                        <span>
                          {" "}
                          {moment(
                            EmpAssessmentList[0]?.FirstReviewerClosureDate
                          ).format("MMM DD YYYY")}
                        </span>
                      </div>
                    </div>
                    <div className="summary-stat">
                      <img src="/images/pms/date.svg" />
                      <div>
                        <span>Assessment Closure By</span>
                        <span>
                          {" "}
                          {moment(EmpAssessmentList[0]?.EndedOn).format(
                            "MMM DD YYYY"
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="emprightside-tabss">
                    <div className="stepper-wrapper00">
                      {steps.map((step) => (
                        <div
                          key={step}
                          className={`stepper-item ${
                            step === currentStatus ? "completed" : "active"
                          }`}
                        >
                          <div className="step-counter">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-check-all"
                              viewBox="0 0 16 16"
                            >
                              <path d="M8.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L2.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093L8.95 4.992a.252.252 0 0 1 .02-.022zm-.92 5.14.92.92a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 1 0-1.091-1.028L9.477 9.417l-.485-.486-.943 1.179z" />
                            </svg>
                          </div>

                          <div className="step-name">{step}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="assessment-questions">
              <div className="illustration-header00">
                <div className="header-meta">
                  <div className="first-divblock">
                    <h3>Assessment Questions</h3>
                    <div className="ml-auto">
                      {/* <Link to="/Assessment/AddNewAssessment/${GUID}"> */}
                      <svg
                        onClick={() => navigatePage(GUID,2)}
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        fill="currentColor"
                        className="bi bi-plus-lg me-3"
                        viewBox="0 0 16 16"
                        style={{ cursor: "pointer" }}
                      >
                        <path
                          fillRule="evenodd"
                          d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"
                        />
                      </svg>
                      {/* </Link> */}
                      <svg
                        onClick={() =>
                          setActiveFAQIndex((prev) => (prev === 1 ? null : 1))
                        }
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-chevron-down"
                        viewBox="0 0 16 16"
                        style={{ cursor: "pointer" }}
                      >
                        <path
                          fillRule="evenodd"
                          d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                        />
                      </svg>
                    </div>
                  </div>

                  <div
                    id={`collapse-${1}`}
                    className={`questions-list ${
                      activeFAQIndex === 1 ? "show" : ""
                    }`}
                    aria-labelledby={`heading-${1}`}
                  >
                    <div className="list-number">
                      <h5>
                        <span>1</span>Deliverables & Customer Focus
                      </h5>
                      <p>Weightage: 50%</p>
                      <div className="question-action">
                        <svg 
                        onClick={() => navigatePage(GUID,2)}
                          width="14"
                          height="14"
                          viewBox="0 0 14 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          className="p-icon p-row-editor-init-icon"
                          data-pc-section="roweditoriniticon"
                        >
                          <path
                            d="M0.609628 13.959C0.530658 13.9599 0.452305 13.9451 0.379077 13.9156C0.305849 13.8861 0.239191 13.8424 0.18294 13.787C0.118447 13.7234 0.0688234 13.6464 0.0376166 13.5614C0.00640987 13.4765 -0.00560954 13.3857 0.00241768 13.2956L0.25679 10.1501C0.267698 10.0041 0.331934 9.86709 0.437312 9.76516L9.51265 0.705715C10.0183 0.233014 10.6911 -0.0203041 11.3835 0.00127367C12.0714 0.00660201 12.7315 0.27311 13.2298 0.746671C13.7076 1.23651 13.9824 1.88848 13.9992 2.57201C14.0159 3.25554 13.7733 3.92015 13.32 4.4327L4.23648 13.5331C4.13482 13.6342 4.0017 13.6978 3.85903 13.7133L0.667067 14L0.609628 13.959ZM1.43018 10.4696L1.25787 12.714L3.50619 12.5092L12.4502 3.56444C12.6246 3.35841 12.7361 3.10674 12.7714 2.83933C12.8067 2.57193 12.7644 2.30002 12.6495 2.05591C12.5346 1.8118 12.3519 1.60575 12.1231 1.46224C11.8943 1.31873 11.6291 1.2438 11.3589 1.24633C11.1813 1.23508 11.0033 1.25975 10.8355 1.31887C10.6677 1.37798 10.5136 1.47033 10.3824 1.59036L1.43018 10.4696Z"
                            fill="currentColor"
                          ></path>
                        </svg>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-trash"
                          viewBox="0 0 16 16"
                           data-toggle="tooltip"
                        data-placement="top"
                        data-bs-toggle="modal"
                        data-bs-target="#delete-questions"
                        title="Remove"
                        data-bs-original-title="delete"
                        aria-label="delete"
                        >
                          <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                          <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                        </svg>
                      </div>
                    </div>

                    <div className="list-number">
                      <h5>
                        <span>2</span>Technical Competence & Strength
                      </h5>
                      <p>Weightage: 20%</p>
                      <div className="question-action">
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 14 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          className="p-icon p-row-editor-init-icon"
                          data-pc-section="roweditoriniticon"
                        >
                          <path
                            d="M0.609628 13.959C0.530658 13.9599 0.452305 13.9451 0.379077 13.9156C0.305849 13.8861 0.239191 13.8424 0.18294 13.787C0.118447 13.7234 0.0688234 13.6464 0.0376166 13.5614C0.00640987 13.4765 -0.00560954 13.3857 0.00241768 13.2956L0.25679 10.1501C0.267698 10.0041 0.331934 9.86709 0.437312 9.76516L9.51265 0.705715C10.0183 0.233014 10.6911 -0.0203041 11.3835 0.00127367C12.0714 0.00660201 12.7315 0.27311 13.2298 0.746671C13.7076 1.23651 13.9824 1.88848 13.9992 2.57201C14.0159 3.25554 13.7733 3.92015 13.32 4.4327L4.23648 13.5331C4.13482 13.6342 4.0017 13.6978 3.85903 13.7133L0.667067 14L0.609628 13.959ZM1.43018 10.4696L1.25787 12.714L3.50619 12.5092L12.4502 3.56444C12.6246 3.35841 12.7361 3.10674 12.7714 2.83933C12.8067 2.57193 12.7644 2.30002 12.6495 2.05591C12.5346 1.8118 12.3519 1.60575 12.1231 1.46224C11.8943 1.31873 11.6291 1.2438 11.3589 1.24633C11.1813 1.23508 11.0033 1.25975 10.8355 1.31887C10.6677 1.37798 10.5136 1.47033 10.3824 1.59036L1.43018 10.4696Z"
                            fill="currentColor"
                          ></path>
                        </svg>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-trash"
                          viewBox="0 0 16 16"
                        >
                          <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                          <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                        </svg>
                      </div>
                    </div>

                    <div className="list-number">
                      <h5>
                        <span>3</span>Behavioural Strength/TeamWork
                      </h5>
                      <p>Weightage: 10%</p>
                      <div className="question-action">
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 14 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          className="p-icon p-row-editor-init-icon"
                          data-pc-section="roweditoriniticon"
                        >
                          <path
                            d="M0.609628 13.959C0.530658 13.9599 0.452305 13.9451 0.379077 13.9156C0.305849 13.8861 0.239191 13.8424 0.18294 13.787C0.118447 13.7234 0.0688234 13.6464 0.0376166 13.5614C0.00640987 13.4765 -0.00560954 13.3857 0.00241768 13.2956L0.25679 10.1501C0.267698 10.0041 0.331934 9.86709 0.437312 9.76516L9.51265 0.705715C10.0183 0.233014 10.6911 -0.0203041 11.3835 0.00127367C12.0714 0.00660201 12.7315 0.27311 13.2298 0.746671C13.7076 1.23651 13.9824 1.88848 13.9992 2.57201C14.0159 3.25554 13.7733 3.92015 13.32 4.4327L4.23648 13.5331C4.13482 13.6342 4.0017 13.6978 3.85903 13.7133L0.667067 14L0.609628 13.959ZM1.43018 10.4696L1.25787 12.714L3.50619 12.5092L12.4502 3.56444C12.6246 3.35841 12.7361 3.10674 12.7714 2.83933C12.8067 2.57193 12.7644 2.30002 12.6495 2.05591C12.5346 1.8118 12.3519 1.60575 12.1231 1.46224C11.8943 1.31873 11.6291 1.2438 11.3589 1.24633C11.1813 1.23508 11.0033 1.25975 10.8355 1.31887C10.6677 1.37798 10.5136 1.47033 10.3824 1.59036L1.43018 10.4696Z"
                            fill="currentColor"
                          ></path>
                        </svg>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-trash"
                          viewBox="0 0 16 16"
                        >
                          <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                          <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                        </svg>
                      </div>
                    </div>

                    <div className="list-number">
                      <h5>
                        <span>4</span>Accountability & Communication
                      </h5>
                      <p>Weightage: 10%</p>
                      <div className="question-action">
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 14 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          className="p-icon p-row-editor-init-icon"
                          data-pc-section="roweditoriniticon"
                        >
                          <path
                            d="M0.609628 13.959C0.530658 13.9599 0.452305 13.9451 0.379077 13.9156C0.305849 13.8861 0.239191 13.8424 0.18294 13.787C0.118447 13.7234 0.0688234 13.6464 0.0376166 13.5614C0.00640987 13.4765 -0.00560954 13.3857 0.00241768 13.2956L0.25679 10.1501C0.267698 10.0041 0.331934 9.86709 0.437312 9.76516L9.51265 0.705715C10.0183 0.233014 10.6911 -0.0203041 11.3835 0.00127367C12.0714 0.00660201 12.7315 0.27311 13.2298 0.746671C13.7076 1.23651 13.9824 1.88848 13.9992 2.57201C14.0159 3.25554 13.7733 3.92015 13.32 4.4327L4.23648 13.5331C4.13482 13.6342 4.0017 13.6978 3.85903 13.7133L0.667067 14L0.609628 13.959ZM1.43018 10.4696L1.25787 12.714L3.50619 12.5092L12.4502 3.56444C12.6246 3.35841 12.7361 3.10674 12.7714 2.83933C12.8067 2.57193 12.7644 2.30002 12.6495 2.05591C12.5346 1.8118 12.3519 1.60575 12.1231 1.46224C11.8943 1.31873 11.6291 1.2438 11.3589 1.24633C11.1813 1.23508 11.0033 1.25975 10.8355 1.31887C10.6677 1.37798 10.5136 1.47033 10.3824 1.59036L1.43018 10.4696Z"
                            fill="currentColor"
                          ></path>
                        </svg>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-trash"
                          viewBox="0 0 16 16"
                        >
                          <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                          <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                        </svg>
                      </div>
                    </div>

                    <div className="list-number">
                      <h5>
                        <span>5</span>Development Areas
                      </h5>
                      <p>Weightage: 10%</p>
                      <div className="question-action">
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 14 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          className="p-icon p-row-editor-init-icon"
                          data-pc-section="roweditoriniticon"
                        >
                          <path
                            d="M0.609628 13.959C0.530658 13.9599 0.452305 13.9451 0.379077 13.9156C0.305849 13.8861 0.239191 13.8424 0.18294 13.787C0.118447 13.7234 0.0688234 13.6464 0.0376166 13.5614C0.00640987 13.4765 -0.00560954 13.3857 0.00241768 13.2956L0.25679 10.1501C0.267698 10.0041 0.331934 9.86709 0.437312 9.76516L9.51265 0.705715C10.0183 0.233014 10.6911 -0.0203041 11.3835 0.00127367C12.0714 0.00660201 12.7315 0.27311 13.2298 0.746671C13.7076 1.23651 13.9824 1.88848 13.9992 2.57201C14.0159 3.25554 13.7733 3.92015 13.32 4.4327L4.23648 13.5331C4.13482 13.6342 4.0017 13.6978 3.85903 13.7133L0.667067 14L0.609628 13.959ZM1.43018 10.4696L1.25787 12.714L3.50619 12.5092L12.4502 3.56444C12.6246 3.35841 12.7361 3.10674 12.7714 2.83933C12.8067 2.57193 12.7644 2.30002 12.6495 2.05591C12.5346 1.8118 12.3519 1.60575 12.1231 1.46224C11.8943 1.31873 11.6291 1.2438 11.3589 1.24633C11.1813 1.23508 11.0033 1.25975 10.8355 1.31887C10.6677 1.37798 10.5136 1.47033 10.3824 1.59036L1.43018 10.4696Z"
                            fill="currentColor"
                          ></path>
                        </svg>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-trash"
                          viewBox="0 0 16 16"
                        >
                          <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                          <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-xl-12 d-none">
            <strong className="assessment-title">Eligible Employees</strong>
            <div className="card">
              <div className="card-body">
                <div className="form-head d-flex flex-wrap align-items-center mb-4">
                  <div className="me-auto w-50">
                    <input
                      type="text"
                      placeholder="search..."
                      className="form-control"
                      style={{ height: "41px" }}
                    />
                  </div>
                  <div className="saving-btn00">
                    <button
                      className="add-m saveby-employee me-2"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Add"
                      onClick={() => navigatePage(GUID,3)}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-plus-lg"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"
                        />
                      </svg>
                    </button>
                    <button
                      className="update-m submitby-employee me-2"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Update"
                      onClick={() => navigatePage(GUID,3)}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-arrow-clockwise"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"
                        />
                        <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
                      </svg>
                    </button>
                    <button
                      className="remove-m submitby-employer me-2"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Remove"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-trash"
                        viewBox="0 0 16 16"
                      >
                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z" />
                        <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z" />
                      </svg>
                    </button>
                    <button
                      className="import-m saveby-employee me-2"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Import"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-box-arrow-in-down"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M3.5 6a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 1 0-1h2A1.5 1.5 0 0 1 14 6.5v8a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 14.5v-8A1.5 1.5 0 0 1 3.5 5h2a.5.5 0 0 1 0 1h-2z"
                        />
                        <path
                          fillRule="evenodd"
                          d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"
                        />
                      </svg>
                    </button>
                    <button
                      className="export-m submitby-employee me-2"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Export"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-box-arrow-in-up"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M3.5 10a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 0 0 1h2A1.5 1.5 0 0 0 14 9.5v-8A1.5 1.5 0 0 0 12.5 0h-9A1.5 1.5 0 0 0 2 1.5v8A1.5 1.5 0 0 0 3.5 11h2a.5.5 0 0 0 0-1h-2z"
                        />
                        <path
                          fillRule="evenodd"
                          d="M7.646 4.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V14.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3z"
                        />
                      </svg>
                    </button>
                    <button
                      className="assign-m submitby-employer me-2"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Assign"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-clipboard-check"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z"
                        />
                        <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z" />
                        <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z" />
                      </svg>
                    </button>
                  </div>
                </div>
                <div className="row">
                  <div className="employee-card tile-grid tile-grid-v1">
                    <div className="table-responsive emp-table">
                      {/* dataTable no-footer */}
                      <table
                        id="example"
                        className="table table-striped table-bordered dataTable no-footer"
                        style={{ width: "100%" }}
                      >
                        <thead>
                          <tr>
                            <th style={{ width: "50px" }}>
                              <div className="form-check custom-checkbox checkbox-success check-lg">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="checkAll"
                                  required=""
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="checkAll"
                                ></label>
                              </div>
                            </th>
                            <th>Name</th>
                            <th>Status</th>
                            <th>Assigned To</th>
                            <th>Score</th>
                            <th>Rating</th>
                            <th>Rating Scale</th>
                            <th>First Reviewer</th>
                            <th>Second Reviewer</th>
                            <th>HR</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr className="odd">
                            <td>
                              <div className="form-check custom-checkbox checkbox-success check-lg">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="customCheckBox2"
                                  required=""
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="customCheckBox2"
                                ></label>
                              </div>
                            </td>
                            <td>
                              <Link to="UserProfile">
                                <div className="d-flex align-items-center">
                                  <img
                                    src="images/avatar/6.jpg"
                                    className="rounded-lg me-2"
                                    width="24"
                                    alt=""
                                  />{" "}
                                  <span className="w-space-no">
                                    Savita Rana
                                  </span>
                                </div>
                              </Link>
                            </td>
                            <td>Closed</td>
                            <td>
                              Arun Mishra
                              <span className="caption-name">
                                (Second Reviewer)
                              </span>{" "}
                            </td>
                            <td>
                              3.9
                              <ul className="score-rate">
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                              </ul>
                            </td>
                            <td>Vital Performance</td>
                            <td>
                              4
                              <ul className="score-rate">
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                              </ul>
                            </td>
                            <td>Alisha Goyal</td>
                            <td>Arun Mishra</td>
                            <td>Pragya Tiwari</td>
                            <td>
                              <div className="d-flex">
                                <a className="btn btn-primary shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-pencil-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                                  </svg>
                                </a>
                                <a className="btn btn-danger shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-trash3-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z" />
                                  </svg>
                                </a>
                                <a className="btn badge light badge-success shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-send-check-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 1.59 2.498C8 14 8 13 8 12.5a4.5 4.5 0 0 1 5.026-4.47L15.964.686Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z" />
                                    <path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-1.993-1.679a.5.5 0 0 0-.686.172l-1.17 1.95-.547-.547a.5.5 0 0 0-.708.708l.774.773a.75.75 0 0 0 1.174-.144l1.335-2.226a.5.5 0 0 0-.172-.686Z" />
                                  </svg>
                                </a>
                              </div>
                            </td>
                          </tr>
                          <tr className="even">
                            <td>
                              <div className="form-check custom-checkbox checkbox-success check-lg">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="customCheckBox2"
                                  required=""
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="customCheckBox2"
                                ></label>
                              </div>
                            </td>
                            <td>
                              <Link to="UserProfile">
                                <div className="d-flex align-items-center">
                                  <img
                                    src="images/avatar/8.jpg"
                                    className="rounded-lg me-2"
                                    width="24"
                                    alt=""
                                  />{" "}
                                  <span className="w-space-no">Sonal</span>
                                </div>
                              </Link>
                            </td>
                            <td>Pending</td>
                            <td>
                              Alisha Goyal
                              <span className="caption-name">
                                (Second Reviewer)
                              </span>{" "}
                            </td>
                            <td>
                              3.9
                              <ul className="score-rate">
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                              </ul>
                            </td>
                            <td>Key Performer</td>
                            <td>
                              4
                              <ul className="score-rate">
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                              </ul>
                            </td>
                            <td>Alisha Goyal</td>
                            <td>Arun Mishra</td>
                            <td>Pragya Tiwari</td>
                            <td>
                              <div className="d-flex">
                                <a className="btn btn-primary shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-pencil-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                                  </svg>
                                </a>
                                <a className="btn btn-danger shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-trash3-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z" />
                                  </svg>
                                </a>
                                <a className="btn badge light badge-success shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-send-check-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 1.59 2.498C8 14 8 13 8 12.5a4.5 4.5 0 0 1 5.026-4.47L15.964.686Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z" />
                                    <path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-1.993-1.679a.5.5 0 0 0-.686.172l-1.17 1.95-.547-.547a.5.5 0 0 0-.708.708l.774.773a.75.75 0 0 0 1.174-.144l1.335-2.226a.5.5 0 0 0-.172-.686Z" />
                                  </svg>
                                </a>
                              </div>
                            </td>
                          </tr>
                          <tr className="odd">
                            <td>
                              <div className="form-check custom-checkbox checkbox-success check-lg">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="customCheckBox2"
                                  required=""
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="customCheckBox2"
                                ></label>
                              </div>
                            </td>
                            <td>
                              <Link to="UserProfile">
                                <div className="d-flex align-items-center">
                                  <img
                                    src="images/avatar/1.jpg"
                                    className="rounded-lg me-2"
                                    width="24"
                                    alt=""
                                  />{" "}
                                  <span className="w-space-no">
                                    Anubhav Singh
                                  </span>
                                </div>
                              </Link>
                            </td>
                            <td>Pending</td>
                            <td>
                              Alisha Goyal
                              <span className="caption-name">
                                (Second Reviewer)
                              </span>{" "}
                            </td>
                            <td>
                              3.9
                              <ul className="score-rate">
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                              </ul>
                            </td>
                            <td>Key Performer</td>
                            <td>
                              4
                              <ul className="score-rate">
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                              </ul>
                            </td>
                            <td>Alisha Goyal</td>
                            <td>Arun Mishra</td>
                            <td>Pragya Tiwari</td>
                            <td>
                              <div className="d-flex">
                                <a className="btn btn-primary shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-pencil-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                                  </svg>
                                </a>
                                <a className="btn btn-danger shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-trash3-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z" />
                                  </svg>
                                </a>
                                <a className="btn badge light badge-success shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-send-check-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 1.59 2.498C8 14 8 13 8 12.5a4.5 4.5 0 0 1 5.026-4.47L15.964.686Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z" />
                                    <path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-1.993-1.679a.5.5 0 0 0-.686.172l-1.17 1.95-.547-.547a.5.5 0 0 0-.708.708l.774.773a.75.75 0 0 0 1.174-.144l1.335-2.226a.5.5 0 0 0-.172-.686Z" />
                                  </svg>
                                </a>
                              </div>
                            </td>
                          </tr>
                          <tr className="even">
                            <td>
                              <div className="form-check custom-checkbox checkbox-success check-lg">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="customCheckBox2"
                                  required=""
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="customCheckBox2"
                                ></label>
                              </div>
                            </td>

                            <td>
                              <Link to="UserProfile">
                                <div className="d-flex align-items-center">
                                  <img
                                    src="images/avatar/2.jpg"
                                    className="rounded-lg me-2"
                                    width="24"
                                    alt=""
                                  />{" "}
                                  <span className="w-space-no">
                                    Dharmesh tyagi
                                  </span>
                                </div>
                              </Link>
                            </td>
                            <td>Pending</td>
                            <td>
                              Alisha Goyal
                              <span className="caption-name">
                                (Second Reviewer)
                              </span>{" "}
                            </td>
                            <td>
                              3.9
                              <ul className="score-rate">
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                              </ul>
                            </td>
                            <td>Key Performer</td>
                            <td>
                              4
                              <ul className="score-rate">
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                              </ul>
                            </td>
                            <td>Alisha Goyal</td>
                            <td>Arun Mishra</td>
                            <td>Pragya Tiwari</td>
                            <td>
                              <div className="d-flex">
                                <a className="btn btn-primary shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-pencil-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                                  </svg>
                                </a>
                                <a className="btn btn-danger shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-trash3-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z" />
                                  </svg>
                                </a>
                                <a className="btn badge light badge-success shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-send-check-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 1.59 2.498C8 14 8 13 8 12.5a4.5 4.5 0 0 1 5.026-4.47L15.964.686Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z" />
                                    <path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-1.993-1.679a.5.5 0 0 0-.686.172l-1.17 1.95-.547-.547a.5.5 0 0 0-.708.708l.774.773a.75.75 0 0 0 1.174-.144l1.335-2.226a.5.5 0 0 0-.172-.686Z" />
                                  </svg>
                                </a>
                              </div>
                            </td>
                          </tr>
                          <tr className="odd">
                            <td>
                              <div className="form-check custom-checkbox checkbox-success check-lg">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="customCheckBox2"
                                  required=""
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="customCheckBox2"
                                ></label>
                              </div>
                            </td>
                            <td>
                              <Link to="UserProfile">
                                <div className="d-flex align-items-center">
                                  <img
                                    src="images/avatar/3.jpg"
                                    className="rounded-lg me-2"
                                    width="24"
                                    alt=""
                                  />{" "}
                                  <span className="w-space-no">Rashika</span>
                                </div>
                              </Link>
                            </td>
                            <td>Pending</td>
                            <td>
                              Alisha Goyal
                              <span className="caption-name">
                                (Second Reviewer)
                              </span>{" "}
                            </td>
                            <td>
                              3.9
                              <ul className="score-rate">
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                              </ul>
                            </td>
                            <td>Key Performer</td>
                            <td>
                              4
                              <ul className="score-rate">
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star"></i>
                                </li>
                                <li>
                                  <i className="fa fa-star no-star"></i>
                                </li>
                              </ul>
                            </td>
                            <td>Alisha Goyal</td>
                            <td>Arun Mishra</td>
                            <td>Pragya Tiwari</td>
                            <td>
                              <div className="d-flex">
                                <a className="btn btn-primary shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-pencil-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                                  </svg>
                                </a>
                                <a className="btn btn-danger shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-trash3-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z" />
                                  </svg>
                                </a>
                                <a className="btn badge light badge-success shadow btn-xs sharp me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    fill="currentColor"
                                    className="bi bi-send-check-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 1.59 2.498C8 14 8 13 8 12.5a4.5 4.5 0 0 1 5.026-4.47L15.964.686Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z" />
                                    <path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-1.993-1.679a.5.5 0 0 0-.686.172l-1.17 1.95-.547-.547a.5.5 0 0 0-.708.708l.774.773a.75.75 0 0 0 1.174-.144l1.335-2.226a.5.5 0 0 0-.172-.686Z" />
                                  </svg>
                                </a>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-xl-12">
            <div className="card">
              <div className="card-body">
                <div className="form-head d-flex flex-wrap align-items-center mb-3">
                  <div className="me-auto w-20">
                    <strong
                      className="ticket-title m-0"
                      style={{ fontWeight: "bolder" }}
                    >
                      Eligible Employees
                    </strong>
                  </div>
                  <div className="saving-btn00">
                    <button
                      className="add-m saveby-employee me-2"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Add"
                       onClick={() => navigatePage(GUID,3)}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-plus-lg"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"
                        />
                      </svg>
                    </button>
                    <button
                      className="update-m submitby-employee me-2"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Update"
                       onClick={() => navigatePage(GUID,3)}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-arrow-clockwise"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"
                        />
                        <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
                      </svg>
                    </button>
                    <button
                      className="remove-m submitby-employer me-2"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Remove"
                        data-bs-toggle="modal"
                        data-bs-target="#delete-eligible"                        
                        data-bs-original-title="delete"
                        aria-label="delete"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-trash"
                        viewBox="0 0 16 16"
                      >
                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z" />
                        <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z" />
                      </svg>
                    </button>
                    <button
                      className="import-m saveby-employee me-2"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Import"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-box-arrow-in-down"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M3.5 6a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 1 0-1h2A1.5 1.5 0 0 1 14 6.5v8a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 14.5v-8A1.5 1.5 0 0 1 3.5 5h2a.5.5 0 0 1 0 1h-2z"
                        />
                        <path
                          fillRule="evenodd"
                          d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"
                        />
                      </svg>
                    </button>
                    <button
                      className="export-m submitby-employee me-2"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Export"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-box-arrow-in-up"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M3.5 10a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 0 0 1h2A1.5 1.5 0 0 0 14 9.5v-8A1.5 1.5 0 0 0 12.5 0h-9A1.5 1.5 0 0 0 2 1.5v8A1.5 1.5 0 0 0 3.5 11h2a.5.5 0 0 0 0-1h-2z"
                        />
                        <path
                          fillRule="evenodd"
                          d="M7.646 4.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V14.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3z"
                        />
                      </svg>
                    </button>
                    <button
                      className="assign-m submitby-employer me-2"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Assign"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-clipboard-check"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z"
                        />
                        <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z" />
                        <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z" />
                      </svg>
                    </button>
                  </div>
                  {/* <div className="actionbutton-tickets">
                            <input className="form-control mr-2 p-inputtext p-component" name="requestTitle" placeholder="Search" data-pc-name="inputtext" data-pc-section="root" />
                            <button className="export-btn" data-toggle="tooltip" data-placement="top" aria-label="Export" data-bs-original-title="Export">
                              <img src="/images/excels.png" alt="export" style={{ width: " 21px" }} /></button>
                          </div> */}
                </div>
                <div className="form-head d-none flex-wrap align-items-center bottom-head">
                  {/* <span className="fil-name">Filter</span> */}
                  <div className="saving-btn00 d-flex w-100">
                    <div className="d-flex d-flexx">
                      {/* <Dropdown
                        name="assignToName"
                        className="w-full md:w-14rem"
                        value={selectedAssingToName}
                        onChange={(e) => {
                          setSelectedAssingToName(e.value);
                          handleInputChange(e);
                        }}
                        options={employeDetails?.toSpliced(0, 0, {
                          id: 0,
                          FullName: "All",
                        })}
                        itemTemplate={employeeOptionTemplate}
                        filter
                        optionLabel="FullName"
                        placeholder="Assign To"
                      />
                      <Dropdown
                        name="fullName"
                        className="w-full md:w-14rem"
                        value={selectedRaiseBy}
                        onChange={(e) => {
                          setSelectedRaiseBy(e.value);
                          handleInputChange(e);
                        }}
                        options={employeDetails?.toSpliced(0, 0, {
                          id: 0,
                          FullName: "All",
                        })}
                        itemTemplate={employeeOptionTemplate}
                        filter
                        optionLabel="FullName"
                        placeholder="Raise By"
                      />
                      <Dropdown
                        name="requestStatus"
                        className="w-full md:w-14rem"
                        // value={ticketMasterDataList?.ticketStatusTypes.find(
                        //   (statusId) => statusId.name == selectedStatus
                        // )}
                        value={selectedStatus}
                        onChange={(e) => {
                          setSelectedStatus(e.value);
                          handleInputChange(e);
                        }}
                        options={ticketStatusType?.toSpliced(0, 0, {
                          Id: 0,
                          Name: "All",
                        })}
                        optionLabel="Name"
                        optionValue="Id"
                        placeholder="Status"
                      />
                      <Dropdown
                        name="CategoryName"
                        value={selectedCategory}
                        onChange={(e) => {
                          setSelectedCategory(e.value);
                          handleInputChange(e);
                        }}
                        options={ticketCategoryType?.toSpliced(0, 0, {
                          Id: 0,
                          Name: "All",
                        })}
                        optionLabel="Name"
                        optionValue="Id"
                        filter
                        placeholder="Category"
                        className="w-full md:w-14rem"
                      />
                      <Dropdown
                        disabled={!ticketSubcategoryTypeSelected}
                        name="subCategory"
                        value={selectedSubCategory}
                        onChange={(e) => {
                          setSelectedSubCategory(e.value);
                          handleInputChange(e);
                        }}
                        options={ticketSubcategoryTypeSelected?.toSpliced(
                          0,
                          0,
                          { Id: 0, Name: "All" }
                        )}
                        optionLabel="Name"
                        optionValue="Id"
                        filter
                        placeholder="Sub Category"
                        className="w-full md:w-14rem"
                      />
                      <Dropdown
                        name="priority"
                        value={selectedPriority}
                        onChange={(e) => {
                          setSelectedPriority(e.value);
                          handleInputChange(e);
                        }}
                        options={ticketPriorityType?.toSpliced(0, 0, {
                          Id: 0,
                          Name: "All",
                        })}
                        optionLabel="Name"
                        optionValue="Id"
                        filter
                        placeholder="Priority"
                        className="w-full md:w-14rem"
                      />
                      <Dropdown
                        name="SeverityName"
                        value={selectedServerity}
                        onChange={(e) => {
                          setSelectedServerity(e.value);
                          handleInputChange(e);
                        }}
                        options={ticketSeverityType?.toSpliced(0, 0, {
                          Id: 0,
                          Name: "All",
                        })}
                        optionLabel="Name"
                        optionValue="Id"
                        filter
                        placeholder="Serverity"
                        className="w-full md:w-14rem"
                      />
                      <span className="startdatefilter">Start Date</span>
                      <InputText
                        type="date"
                        name="CreatedDate"
                        placeholder="Date"
                        className="form-control mr-2"
                        value={startDate}
                        onChange={handleInputChange}
                      />
                      <span className="enddatefilter">End Date</span>
                      <InputText
                        type="date"
                        name="EndDate"
                        placeholder="Date"
                        className="form-control mr-2"
                        value={endDate}
                        onChange={handleInputChange}
                        min={startDate}
                      /> */}
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="table table-bordered dataTable no-footer tickettable">
                    <DataTable
                      value={eligibleEmployees}
                      className="ticket-datatable"
                    >
                      <Column selectionMode="multiple" />
                      <Column
                        field="EmployeeName"
                        header="Name"
                        style={{ minWidth: "16rem" }}
                      />
                      <Column
                        field="AssessmentStatus"
                        header="Status"
                        style={{ minWidth: "6rem" }}
                      />
                      <Column
                        field="AssessmentStatus"
                        header="Assigned To"
                        style={{ minWidth: "6rem" }}
                      />
                      <Column field="AssessmentStatus" header="Score" />
                      <Column
                        field="AssessmentStatus"
                        header="Rating"
                        style={{ minWidth: "6rem" }}
                      />
                      <Column header="Rating Scale" field="AssessmentStatus" />
                      <Column
                        header="First Reviewer"
                        field="AssessmentStatus"
                      />

                      <Column
                        field="AssessmentStatus"
                        header="Second Reviewer"
                        style={{ minWidth: "6rem" }}
                      />

                      <Column
                        field="AssessmentStatus"
                        header="HR"
                        filterMenuStyle={{ width: "6rem" }}
                        style={{ minWidth: "6rem" }}
                      />
                      <Column
                        // body={actionBodyTemplate}
                        header="Action"
                        style={{ width: "93px" }}
                      />
                    </DataTable>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="review-request"
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title m-auto">
                Form Submitted Successfully. Now Sent the Review Request.
              </h5>
            </div>
            <div className="modal-body text-center">
              <form>
                <div className="form-group text-left">
                  <label>Request to</label>
                  <select className="default-select form-control wide mb-3">
                    <option selected disabled>
                      Select
                    </option>
                    <option>Employee Review</option>
                    <option>Review</option>
                    <option>HR Review</option>
                  </select>
                </div>
                <div className="form-group text-left">
                  <label className="mt-3">Add your Comment</label>
                  <textarea
                    rows="4"
                    cols="1"
                    className="form-control"
                  ></textarea>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-danger light"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button type="button" className="btn btn-primary">
                Sumbit
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade" id="delete-ed">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content delete-holiday">
            <div className="modal-header">
              <img
                src="/images/org-img/leave/popup-backimg.png"
                className="backimg"
              />
              <div className="img">
                <img src="/images/org-img/leave/trash.png" />
              </div>
            </div>
            <div className="modal-body text-center">
              <strong className="modal-title">Are you sure?</strong>
              <p>Do you really want to delete this Review?</p>
            </div>
            <div className="modal-footer m-auto">
              <button
                type="button"
                className="cancelbtn-click"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                className="deletebtn-click"
                data-bs-dismiss="modal"
                // onClick={() => deleteAnnouncementDetails()}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
       <div className="modal fade" id="delete-questions">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content delete-holiday">
            <div className="modal-header">
              <img
                src="/images/org-img/leave/popup-backimg.png"
                className="backimg"
              />
              <div className="img">
                <img src="/images/org-img/leave/trash.png" />
              </div>
            </div>
            <div className="modal-body text-center">
              <strong className="modal-title">Are you sure?</strong>
              <p>Do you really want to delete this Questions?</p>
            </div>
            <div className="modal-footer m-auto">
              <button
                type="button"
                className="cancelbtn-click"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                className="deletebtn-click"
                data-bs-dismiss="modal"
                // onClick={() => deleteAnnouncementDetails()}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
       <div className="modal fade" id="delete-eligible">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content delete-holiday">
            <div className="modal-header">
              <img
                src="/images/org-img/leave/popup-backimg.png"
                className="backimg"
              />
              <div className="img">
                <img src="/images/org-img/leave/trash.png" />
              </div>
            </div>
            <div className="modal-body text-center">
              <strong className="modal-title">Are you sure?</strong>
              <p>Do you really want to delete this eligible employees?</p>
            </div>
            <div className="modal-footer m-auto">
              <button
                type="button"
                className="cancelbtn-click"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                className="deletebtn-click"
                data-bs-dismiss="modal"
                // onClick={() => deleteAnnouncementDetails()}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
      {loading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
}

export default AssessmentCycle;
